{
  "global": {
    "account": "Account | Accounts",
    "activity": "Activiteit | Activiteiten",
    "action": "Actie | Acties",
    "administration": "Administratie",
    "address": "Adres | Adressen",
    "add_object": "Voeg {object} toe",
    "anyone": "Wie dan ook",
    "api": "API",
    "assigned_to": "Toegewezen aan",
    "attach_subject": "{subject} bijvoegen",
    "author": "Auteur | Auteurs",
    "automatically_refreshing": "De pagina ververst automatisch",
    "by": "Door",
    "cancel": "Annuleer",
    "city": "Stad",
    "click_to_delete": "Klik om te verwijderen",
    "click_to_edit": "Klik om te bewerken",
    "click_to_view": "Klik om te bekijken",
    "close": "Sluit",
    "closed": "Gesloten",
    "closed_on": "Gesloten op",
    "company": "Bedrijf | Bedrijven",
    "confirm_message": "Weet je het zeker?",
    "contact": "Contact | Contacten",
    "continue": "Doorgaan",
    "count": "Telling",
    "create": "Aanmaken",
    "created_at": "Aangemaakt op",
    "created_by": "Aangemaakt door",
    "create_continue": "Aanmaken en doorgaan",
    "create_object": "{object} aanmaken",
    "date": "Datum | Datums",
    "dashboard": "Dashboard | Dashboards",
    "default": "Standaard",
    "delete": "Verwijder",
    "deleted": "Verwijderd",
    "description": "Omschrijving",
    "details_show": "Toon details",
    "difference": "Verschil",
    "download": "Downloaden",
    "edit": "Bewerk",
    "edit_subject": "Bewerk {subject}",
    "email": "Email | Emails",
    "enter": "Voer in",
    "enter_subject": "Voer {subject} in",
    "error_generic": "Er ging iets verkeerd. Probeer het later nog eens.",
    "example": "Voorbeeld",
    "exclude": "Sluit uit",
    "export": "Exporteer",
    "file": "Bestand | Bestanden",
    "filename": "Bestandsnaam | Bestandsnamen",
    "from": "Van",
    "goto_subject": "Ga naar {subject}",
    "health": "Gezondheid",
    "id": "Id | Ids",
    "latitude": "Breedtegraad",
    "list": "Lijst | Lijsten",
    "loading": "Laden",
    "log_out": "Uitloggen",
    "longitude": "Lengtegraad",
    "location": "Locatie | Locaties",
    "management": "Beheer",
    "map": "Kaart | Kaarten",
    "me": "Mijzelf",
    "metric": "Meting | Metingen",
    "name": "Naam",
    "name_first": "Voornaam",
    "name_last": "Achternaam",
    "no": "Nee",
    "note": "Notitie | Notities",
    "notification": "Notificatie | Notificaties",
    "ok": "Ok",
    "open": "Open",
    "open_new_window": "Open in nieuw venster",
    "operation": "Operatie | Operaties",
    "option": "Optie | Opties",
    "other": "Anders | Anderen",
    "overview": "Overzicht",
    "owner": "Eigenaar",
    "password": "Wachtwoord | Wachtwoorden",
    "period": "Periode | Periodes",
    "phone_number": "Telefoonnummer",
    "postal_code": "Postcode",
    "ratio": "Verhouding",
    "ratio_difference": "Verhouding verschil",
    "report": "Rapport | Rapporten",
    "reset": "Opnieuw instellen",
    "retired": "Gedeactiveerd",
    "result": "Resultaat",
    "save": "Opslaan",
    "save_continue": "Opslaan en doorgaan",
    "select": "Selecteer",
    "select_an_option": "Selecteer een optie",
    "select_a_date": "Selecteer een datum",
    "separator": "Verdeler | Verdelers",
    "show_all": "Toon alles",
    "status": "Status | Statussen",
    "setting": "Instelling | Instellingen",
    "shade": "Schaduw",
    "skip": "Overslaan",
    "street": "Straat | Straten",
    "house_number": "Huisnummer",
    "summary": "Samenvatting",
    "support": "Ondersteuning",
    "test": "Test | Testen",
    "title": "Titel",
    "to": "Tot",
    "tonnes": "Ton",
    "type": "Type",
    "unknown": "Onbekend",
    "user": "Gebruiker | Gebruikers",
    "value": "Waarde | Waardes",
    "yes": "Ja"
  },
  "glossary": {
    "angle": "Hoek",
    "angle_in_degrees": "Helling in graden",
    "attached_companies": "Bijgevoegde bedrijven",
    "cents_per_kwh": "Cent per kWh",
    "current_period": "Huidige periode",
    "custom_fields": "Aangepaste velden",
    "driver": "Omvormer | Omvormers",
    "driver_account": "Omvormer account | Omvormer accounts",
    "energy": "Energie",
    "energy_expected": "Verwachtte energie",
    "energy_generated": "Opgebrachte energie",
    "energy_lacking": "Missende energie",
    "found_on": "Gevonden op",
    "issue": "Issue | Issues",
    "long_term": "Lange Termijn",
    "ltpm": "Prestatiemonitoring Op Lange Termijn",
    "meter": "Meter | Meters",
    "monitored_since": "Gemonitord sinds",
    "monitoring": "Monitoring",
    "monitoring_activate": "Activeer monitoring",
    "operational_since": "Operationeel sinds",
    "orientation": "Oriëntatie",
    "orientation_in_degrees": "Oriëntatie in graden",
    "panel": "Paneel | Panelen",
    "peak_total": "Totale piek",
    "peak_watt": "Wattpiek",
    "performance": "Prestatie | Prestaties",
    "performance_monitoring": "Prestatiemonitoring",
    "performance_ratio": "Prestatie Verhouding | Prestatie Verhoudingen",
    "performance_ratio_7d": "7 Dagen Prestatie Verhouding",
    "performance_ratio_30d": "30 Dagen Prestatie Verhouding",
    "performance_ratio_daily": "Dagelijkse Prestatie Verhouding | Dagelijkse Prestatie Verhoudingen",
    "plant": "Installatie | Installaties",
    "plant_code": "Installatiecode",
    "plant_name": "Installatienaam",
    "resolved_on": "Opgelost op",
    "retired_on": "Gedeactiveerd op",
    "saved_co2": "Bespaarde CO2",
    "snoozed_until": "Gesnoozed tot",
    "tag": "Tag | Tags",
    "ticket": "Ticket | Tickets",
    "yield_insight": "Opbrengst Inzicht | Opbrengst Inzichten"
  },
  "temporary": {
    "message_panel_groups_need_update": "Er zijn {count} installaties die een gemengde oriëntatie hebben en maar één paneelgroep. Ga naar 'Installaties' en zet het Gemengde oriëntatie filter op 'Gemengd' en het Paneelgroepen filter op 'Nee' om deze installaties te bekijken."
  },
  "investigations": {
    "drawer_title": "Onderzoeken ({count})",
    "help_title": "Onderzoeken",
    "help_description": "We hebben geprobeerd te achterhalen wat er aan de hand is bij deze installatie. Hieronder lees je meer over onze aanbevelingen. Deze feature is nog in ontwikkeling.",
    "found_on": "Gevonden {date}",
    "updated_on": "Laatst bijgewerkt {date}",
    "steps_toggle": "Toon checks",
    "activity_toggle": "Activiteit sinds gevonden ({count})",
    "issues_toggle": "Betrokken issues ({count})",
    "actions": {
      "helpful": "Nuttig?",
      "thumbs_up": "Ja, dit was nuttig",
      "thumbs_down": "Nee, dit was niet nuttig",
      "snooze": "7 dagen verbergen",
      "snooze_title": "Verberg dit onderzoek 7 dagen. Handig als je al bezig bent met het oplossen.",
      "acknowledge": "Gezien & afgehandeld",
      "acknowledge_title": "Markeer als gezien. Het onderzoek wordt tijdelijk verborgen zodat het systeem je inspanningen kan verwerken."
    }
  },
  "features": {
    "activity": {
      "not_found": "Geen activiteit gevonden | Geen activiteiten gevonden"
    },
    "tips": {
      "add_column": "Bekijk meer installatie eigenschappen met de knop Voeg Kolom toe",
      "aerial_photo": "Navigeer naar het enkele installatie locatie tabje voor een recente luchtfoto",
      "diagnostics": "Niet zeker wat er mis is met een meter? Probeer meter diagnostiek op het meter tabje!",
      "filter_preset": "Sla vaak gebruikte filters op als een filter voorinstelling",
      "locale_switch": "Je kan van taal wisselen door het klikken op je avatar rechtsboven",
      "map_filter": "Filtering werkt ook op de kaart. B.v. bij het zoeken naar hoge voltage issues",
      "notes_files": "Sla installatie specifieke informatie op onder het notities en bestanden tabje",
      "search_everywhere": "Gebruik Zoek Overal om naar installaties te zoeken vanaf elke pagina",
      "sundata_support": "Je kan ondersteuning aanvragen op een ticket door het aanwijzen van Sundata Support",
      "whats_new": "Op de hoogte blijven van updates? Bezoek de Nieuwigheden pagina via het menu"
    },
    "account": {
      "settings": "Account instellingen",
      "settings_for": "Instellingen voor {user}",
      "setting_email": "E-mail instelling",
      "daily_status": "Dagelijkse status e-mail",
      "daily_status_description": "Status e-mails informeren je over de status veranderingen van je installaties",
      "daily_status_receive": "Ontvang dagelijkse status e-mails",
      "unsubscribed_header": "E-mails uitgezet",
      "unsubscribed_disabled": "E-mails naar het adres {address} zijn automatisch uitgezet. Je ontvangt geen e-mail op het moment.",
      "unsubscribed_stop_when": "We stoppen met het sturen van e-mails wanneer we",
      "unsubscribed_bounced": "Merken dat e-mails worden teruggezonden",
      "unsubscribed_spam": "Je een spam melding hebt gemaakt op een status e-mail",
      "unsubscribed_other": "Je je op een andere manier hebt uitgeschreven op de status e-mails",
      "unsubscribed_support": "Contacteer ons support team om dit probleem op te lossen."
    },
    "address_form": {
      "not_found": "Postcode + huisnummer niet gevonden",
      "not_found_description": "We konden geen adres vinden voor de gegeven postcode en huisnummer. Dit kan zijn omdat de gegevens incorrect zijn. Wanneer je zeker bent dat de combinatie correct is kan je de andere gegevens handmatig invullen.",
      "invalid_postal_code": "De postcode is ongeldig. Voer alsjeblieft een geldige postcode in",
      "lat_lon_tool_info": "Een fijne website om handmatig de lengte- en breedtegraad te vinden voor elke locatie is de {website_name}",
      "lat_lon_tool_name": "GPS coordinaten website",
      "already_exists": "Adres bestaat al. Weet je zeker dat je door wilt gaan?"
    },
    "credentials": {
      "credentials": "Toegangsgegevens",
      "credential_values": "Toegangsgegevens",
      "credential_composition": "Samenstelling",
      "credential_composition_explanation": "Er zijn meerdere samenstellingen van toegegevens mogelijk, voor deze omvormer account.",
      "feedback_validating": "Toegangsgegevens valideren",
      "feedback_already_exists": "Meter bestaat al, voer alsjeblieft de unieke id in van de meter.",
      "feedback_invalid": "De ingevoerde meter is ongeldig. Check de ingevoerde data alsjeblieft",
      "feedback_valid": "Toegangsgegevens zijn geldig"
    },
    "create_meter": {
      "add_to": "Voeg meter toe aan",
      "low_peak_watt": "Deze waarde is aan de lage kant. Is dit correct?",
      "operational_since_tooltip": "Kan tot een jaar terug zijn."
    },
    "create_plant": {
      "feedback_enter_name": "Voer alsjeblieft een naam in",
      "feedback_monitored_since": "Voor de gemonitord sinds datum in",
      "tags_companies": "Tags en bedrijven"
    },
    "health": {
      "sub_title": "Lange termijn prestatie monitoring en problemen gegroupeerd op de datum date ze gevonden zijn"
    },
    "check_panel_group_roof": {
      "check_roof_surface": "Dakvlak controleren",
      "values_filled_in": "De oriëntatie en helling van het gekozen dakvlak zijn ingevuld bij paneelgroep {name}. Controleer de waarden en sla op."
    },
    "update_meter": {
      "edit_meter": "Bewerk meter",
      "no_permission_message": "Je hebt geen toestemming om deze meter te bewerken omdat je bedrijf {company} niet de eigenaar is van deze installatie.",
      "success_message": "Meter bewerking geslaagd! De dialoog sluit over 2 seconden..."
    },
    "retire_meter": {
      "retire_meter": "Deactiveer meter",
      "retirement_date": "Deactivatie datum",
      "alert_message": "Dit bewaart de opbrengst, maar stopt de meter van het krijgen van een status. Dit kan niet ongedaan gemaakt worden.",
      "success_message": "De meter is gedeactiveerd! De dialoog sluit over 2 seconden..."
    },
    "custom_field": {
      "not_empty": "Het is niet mogelijk om een leeg veld op te slaan"
    },
    "linked_fields_overview": {
      "owned": "Eigen velden",
      "visible": "Zichtbare velden",
      "attached": "Bijgevoegde velden",
      "belongs_to": "Dit veld behoort tot {company}",
      "viewed_by": "Deze velden zijn zichtbaar voor {company}",
      "removed": "{field} verwijderd van {company}",
      "removed_fail": "Niet gelukt om veld van bedrijf te verwijderen",
      "added": "{field} toegevoegd aan {company}",
      "added_fail": "Niet gelukt om veld aan bedrijf toe te voegen",
      "help_intro": "Met aangepaste velden sla je je eigen informatie op bij installaties, zoals een projectnummer, installateur of contractvorm.",
      "help_columns": "Toon ze als kolommen in het installatie-overzicht",
      "help_filters": "Filter en zoek installaties op hun waarden",
      "help_plants": "Vul ze in bij het aanmaken of bewerken van een installatie",
      "help_request": "Je bedrijf heeft nog geen aangepaste velden. Neem contact met ons op via de chat om ze in te stellen."
    },
    "child_company_tags": {
      "attached": "Bijgevoegde tags",
      "viewed_by": "Deze tags kunnen gezien worden door {company}",
      "no_tags": "{company} heeft geen tags",
      "removed": "{tag} verwijderd van {company}",
      "removed_fail": "Niet gelukt om de tag van het bedrijf te verwijderen",
      "added": "{tag} toegevoegd aan {company}",
      "added_fail": "Niet gelukt om tag aan het bedrijf toe te voegen"
    },
    "create_note": {
      "button": "Maak notitie aan",
      "checkbox_title": "Toont de notitie alleen binnen {company}",
      "placeholder": "Laat een notitie achter over deze installatie",
      "private": "Privé"
    },
    "note_list": {
      "delete_note_confirm": "Weet je zeker dat je deze notitie wilt verwijderen?",
      "only_visible_to": "Alleen zichtbaar voor {company}"
    },
    "dashboard_issues": {
      "chart_description": "We hebben het dashboard verbeterd om je te helpen focussen op de installaties die aandacht nodig hebben ten opzichte van de goedlopende installaties.",
      "chart_sub_title": "Gevonden en opgeloste problemen in de geselecteerde periode",
      "chart_title": "Problemen Grafiek",
      "sub_title": "Geteld voor onopgeloste problemen",
      "title": "Geteld per type"
    },
    "dashboard_performance": {
      "sub_title": "Een overzicht van de prestatie van het bedrijf over de geselecteerde periode."
    },
    "panel_config_form": {
      "help_message": "Niet zeker van de orientatie en helling van de panelen? {link}",
      "help_message_link": "Klik hier voor hulp"
    },
    "panel_config_helper": {
      "title": "Selecteer dakvlak voor paneel instellingen",
      "title_for_panel_group": "Selecteer dakvlak voor paneelgroep '{name}'",
      "loading": "Dakvlakken ophalen",
      "click_to_select": "Klik op een dakvlak om te selecteren",
      "current_settings": "Huidige instellingen",
      "selected_settings": "Geselecteerd dakvlak",
      "select_and_edit": "Selecteer en bewerk meter",
      "table": {
        "title": "Dakvlakken",
        "color": "Dakvlak kleur",
        "area": "Oppervlakte in m2"
      }
    },
    "plants": {
      "sub_title": "Zoek naar specifieke installaties",
      "empty": "Geen installaties gevonden!"
    },
    "plant_issues": {
      "tooltip_occurrence": "voorvallen van",
      "tooltip_with_snoozed": "met tenminste een gesnoozde tot"
    },
    "plant_report": {
      "button_label": "Reportage Downloaden",
      "title": "Installatie Reportage",
      "please_hold": "Het maken van een reportage kan enkele ogenblikken duren. Met name wanneer er meerdere meters betrokken zijn.",
      "open_window": "Open in nieuw venster"
    },
    "location": {
      "button_pdok_aerial": "Luchtfoto",
      "button_pdok_height": "Hoogtekaart"
    },
    "plant_issue_filter": {
      "dont_show": "Toon geen problemen met de volgende nieuwe issues",
      "show": "Toon alleen problemen met de volgende nieuwe issues"
    },
    "plant_tickets_filter": {
      "has_ticket": "Heeft een ticket",
      "no_ticket": "Heeft geen tickets",
      "open_ticket": "Heeft een open ticket",
      "no_open_ticket": "Heeft geen open tickets"
    },
    "plant_custom_field_filter": {
      "no_fields_found": "Geen aangepaste velden gevonden!"
    },
    "export_tab": {
      "help_description": "Gebruik ';' voor computers in het Nederlands"
    },
    "help_icon": {
      "go_to_support": "Ga naar support artikel"
    },
    "single_plant": {
      "tags_edit": "Bewerk tags",
      "companies_edit": "Bewerk bedrijven",
      "custom_fields_edit": "Bewerk aangepaste velden",
      "nr_active_meters": "Aantal actieve meters",
      "analyse_period": "Analyseer periode",
      "shade_past_14_days": "{days_nr} / 14 dagen"
    },
    "single_plant_performance": {
      "sub_title": "Prestatie grafieken in meerdere dimensies",
      "weekly_lifetime": {
        "sub_title": "Wekelijkse prestatie verhoudingen sinds het begin van de monitoring"
      },
      "hour_pr": {
        "sub_title": "Uurlijkse prestatie verhoudingen"
      },
      "chart_warning_expected_incomplete": "De laatste {nr_periods} periode(s) zijn niet getoond omdat de verwachte energie nog niet compleet is."
    },
    "single_plant_issues": {
      "show_resolved": "Toon opgeloste",
      "notifications_over_time": "Notificaties door de tijd",
      "status_type_info": "Statustype informatie",
      "row_types": {
        "meter-statuses": "Bevindingen per dag",
        "meter-issues": "Issues"
      }
    },
    "single_plant_long_term": {
      "sub_title": "Monitoring van prestatie over periodes van een jaar",
      "tooltip_description": "Wanneer een installatie aangemaakt is heb je waarschijnlijk een belofte gemaakt over de jaarlijkse opbrengst. Lange termijn monitoring helpt je deze beloftes te monitoren.",
      "message_no_ltpm": "Deze installatie heeft nog geen lange termijn monitoring. Dit kan zijn omdat deze installatie pas recent gemonitord wordt ({date}). Het duurt meestal een week voordat de monitoring begint. Kom aub later terug."
    },
    "single_plant_location": {
      "button_3dbag": "Dakvlak helling check"
    },
    "single_plant_meters": {
      "sub_title": "Meters gekoppeld aan deze installatie.",
      "retired_tooltip": "Dit bewaart de opbrengst, maar stopt de meter van het krijgen van een status"
    },
    "single_plant_contacts": {
      "sub_title": "Bewoners of andere personen behorend bij deze installatie.",
      "plant_contact": "Installatie contact"
    },
    "search_cart": {
      "advanced_search": "Geavanceerd zoeken",
      "search": "Zoek overal",
      "type_to_start": "Begin met typen om te zoeken.."
    },
    "issues": {
      "sub_title": "Installaties met problemen",
      "help_description": "Geeft problemen met de installatie weer",
      "found_on_tooltip": "Datum waarop het issue was gevonden",
      "open": "Openstaande issues",
      "no_open": "Er zijn geen openstaande issues",
      "snoozed": {
        "snooze_issue": "Snooze issue",
        "snooze_for": "Snooze voor",
        "snoozed_success": "Issue succesvol gesnoozed! Dialoog sluit over 2 seconden...",
        "unsnooze_issue_confirm": "Weet je zeker dat je het issue wilt ontsnoozen?"
      }
    },
    "date_range_picker": {
      "last_7d": "Afgelopen 7 dagen",
      "last_6w": "Afgelopen 6 weken",
      "last_12m": "Afgelopen 12 maanden"
    },
    "period_picker": {
      "hours": "In uren",
      "days": "In dagen",
      "weeks": "In weken",
      "months": "In maanden"
    },
    "meter_picker": {
      "all_meters": "Alle meters"
    },
    "main_menu": {
      "all_tickets": "Alle tickets",
      "single_ticket": "Enkel ticket",
      "all_plants": "Alle installaties",
      "single_plant": "Enkele installatie",
      "password_reset": "Wachtwoord resetten",
      "password_forgot": "Wachtwoord vergeten",
      "sign_in": "Inloggen",
      "whats_new": "Nieuwigheden"
    },
    "main_menu_driver_status": {
      "unavailable": "Omvormer status niet beschikbaar",
      "degraded": "Omvormer uitval",
      "ok": "Alle omvormers ok"
    },
    "file_list": {
      "view_in_new_window": "Open in nieuw scherm",
      "delete_file_confirm": "Weet je zeker dat je dit bestand wilt verwijderen?"
    },
    "filtering": {
      "groups": {
        "plant": "Installatie",
        "address": "Adres",
        "status": "Status",
        "tickets": "Tickets",
        "meter": "Meter"
      },
      "names": {
        "query": "Zoek",
        "assigned_to": "Ticket aangewezene",
        "ticket_status": "Ticket status",
        "template": "Template",
        "issues": "Issues",
        "issues_new": "Nieuwe issues",
        "issues_existing": "Bestaande issues",
        "snoozed_issue": "Gesnoozde issues",
        "resolved_issue": "Opgeloste issues",
        "mixed_orientation": "Gemengde oriëntatie",
        "multiple_panel_groups_filter": "Paneelgroepen",
        "has_meter": "Heeft meter",
        "non_mon": "Light installaties",
        "plant_code": "Installatiecode",
        "tickets": "Tickets"
      },
      "labels": {
        "query": "Zoek op installaties",
        "assigned_to": "Toegewezen aan",
        "ticket_status": "Ticket status",
        "template_ids": "Filter op ticket template",
        "tag_ids": "Filter op tag",
        "postal_code": "Zoek op postcode",
        "street": "Zoek op straat",
        "street_number": "Zoek op huisnumer",
        "city": "Stad",
        "driver_account_ids": "Filter op omvormer",
        "child_company_ids": "Filter op bijgevoegd bedrijf",
        "peak_in_watt": "Filter op piek Watt",
        "operational_since": "Filter op operationele datum",
        "monitored_since": "Filter op gemonitord sinds datum",
        "monitored": "Filter op Light installaties",
        "issues": "Issues",
        "snoozed_issue": "Inclusief gesnoozde issues",
        "resolved_issue": "Inclusief opgeloste issues",
        "ltpm": "Prestatiemonitoring:",
        "found_on": "Gevonden op",
        "mixed_orientation": "Filter op gemengde paneel orientatie",
        "multiple_panel_groups": "Heeft meerdere paneelgroepen",
        "has_meter": "Heeft een meter?",
        "custom_fields": "Filter op aangepast veld",
        "plant_code": "Filter op Installatiecode",
        "tickets": "Tickets",
        "ticket_child_company_ids": "Filter op bijgevoegd bedrijf",
        "new_issues": "Nieuwe issues",
        "yield_score_7d": "Filter op 7 dagen prestatie verhouding",
        "yield_score_30d": "Filter op 30 dagen prestatie verhouding",
        "remove_filter": "Verwijder filter",
        "filter_preset": "Filter voorinstelling | Filter voorinstellingen",
        "copy_to_search_cart": "Kopieer naar zoek overal",
        "credential_values": "Filter toegangsgegevens"
      },
      "explanations": {
        "issues": "Filter op de issues van een in installatie",
        "issues_new": "Filters op de 'Nieuwe Issues'. Negeert bestaande issues",
        "monitored_since": "De dag vanaf dat de installatie gemonitord wordt",
        "operational_since": "De dag vanaf dat de installatie operationeel is",
        "long_term": "Filter op de prestatie van de huidige periode"
      },
      "presets": {
        "empty": "Begin door filters te kiezen- en ze te bewaren.",
        "store_title": "Filters bewaren",
        "store": "Filters bewaren",
        "prompt_alias": "Geef een naam aan deze filters.",
        "management_title": "Beheer filter voorinstellingen",
        "level_company": "Bedrijfs voorinstellingen",
        "level_user": "Persoonlijke voorinstellingen"
      },
      "glossary": {
        "mixed": "Gemengd",
        "uniform": "Uniform"
      }
    },
    "historical_summary": {
      "over_period": "Samenvatting over periode",
      "checks_for_meter": "Controles voor meter id {meter_id}"
    },
    "performance_statistics": {
      "energy_expected_total_period": "Totale verwachtte energie in periode",
      "energy_generated_total_period": "Totale opgebrachte energie in periode",
      "forecast_ratio_about": "Over deze Prestatie Verhouding",
      "forecast_ratio_over_period": "Prestatie Verhouding over periode",
      "saved_co2_total_period": "Totale bespaarde CO2 in periode"
    },
    "performance_ratio": {
      "description": "De verhouding tussen de opgebrachte en verwachtte opbrengst van een installatie over de afgelopen {days} dagen"
    },
    "long_term": {
      "period_progress": "Periode vooruitgang",
      "progress": "Vooruitgang",
      "promised_till_now": "Beloofd tot nu",
      "promised": "Beloofd",
      "last_14d": "Over de laatste 14 dagen",
      "sub_title": "Een overzicht van de lange termijn prestatie van je installaties over meerdere jaren. Elke jaar periode is getoond als een enkel icoontje. Je bent zelf in controle over de opbrengst die je verwacht in een periode voor een installatie.",
      "summary": {
        "early": "Het is <strong>te vroeg</strong> om iets te zeggen over deze periode.",
        "ahead": "De prestatie in de huidige periode loopt <strong>voor</strong> op schema.",
        "far_ahead": "De prestatie in de huidige periode loopt <strong>erg voor</strong> op schema.",
        "behind": "De prestatie loopt <strong>achter</strong> maar kan nog goed komen.",
        "severely_behind": "De prestatie loopt <strong>ernstig achter</strong> en komt waarschijnlijk niet goed.",
        "not_configured": "Deze periode is nog niet ingesteld. Je kan dit handmatig doen, of wachten op de automatische instelling de volgende dag.",
        "unknown": "De applicatie kreeg een onverwachte vlag. Laat het ons alsjeblieft weten, dan lossen wij het op. Dank!"
      },
      "insight": {
        "reason": "De voornaamste reden voor missende opbrengst in deze periode is '{reason}'."
      },
      "explainer": {
        "period_title": "Periode {start} tot {end}",
        "setting_description": "De lange termijn monitoring for deze installatie start op de {date} en is ingesteld op {setting}.",
        "setting_updating": "Deze periode wordt aangepast. Probeer de pagina te herladen na enkele minuten.",
        "ongoing_irradiance": "Deze periode heeft {irradiance_percentage} van de zoninstraling gehad.",
        "ongoing_early": "Dit betekent dat het {term} is om sterke conclusies te trekken. Het zou kunnen helpen om te kijken naar eerdere periodes.",
        "ongoing_delivered_till_now": "Tot nu toe is er {delivered} opgeleverd{including_gap_fills}.",
        "ongoing_behind": "Dit betekent dat de installatie {missing} achterloopt. Om dit in te halen moet de installatie {needed} opbrengen voor de rest van de periode.",
        "ongoing_ahead": "Dit betekent dat de installatie {term} met {ahead}.",
        "ended_total": "Deze periode is afgelopen. In totaal is er {delivered} opgebracht. De voor het weer gecorrigeerde drempelwaarde is {promised}.",
        "ended_result": "Dit betekent dat de installatie {result} heeft geproduceerd dan wat was ingesteld.",
        "too_early": "te vroeg",
        "ahead": "voor loopt",
        "within_05": "binnen de 0.5%",
        "less": "minder",
        "more": "meer",
        "change_settings": "Wijzig instellingen"
      },
      "gap_fills": {
        "button_add_view": "Vul opbrengst aan en bekijk aanvullingen",
        "create_error": "Aanvulling kon niet worden aangemaakt.",
        "create_success": "Aanvulling aangemaakt! De periode wordt nu geüpdatet. Kom later terug om de verandering te zien.",
        "delete_confirm": "Weet je zeker dat je deze aanvulling wilt verwijderen?",
        "dialog_period_ahead": "De periode loopt voor met {yield_ahead}. Een aanvulling is niet nodig.",
        "dialog_period_yield": "In deze periode is {yield_actual} opgewekt. Daarvan is {yield_filled} aangevuld.",
        "dialog_period_missing": "Er mist nog {yield_missing}.",
        "existing_item": "Op {created_at} is {yield} aangevuld met reden: {reason}",
        "existing_title": "Bestaande aanvullingen",
        "gap_fill": "Aanvulling | Aanvullingen",
        "gap_fill_including": ", inclusief aanvullingen",
        "gap_fills_created_wh": "Er is {yield} aangevuld voor deze periode.",
        "gap_fills_none_created": "Er zijn geen aanvullingen aangemaakt.",
        "intro": "Aanvullingen zijn bedoeld om bekende gaten in opbrengst te accepteren. Dit houdt de lange termijn monitoring relevant.",
        "modal_title": "Lange termijn opbrengst aanvullingen",
        "period_ended": "Let op! De periode is afgelopen.",
        "reason": "Reden",
        "reason_none": "Geen reden opgegeven"
      },
      "columns": {
        "status_since": "Status sinds",
        "status_since_tooltip": "Toont hoe ver terug de kleur van de huidige periode voor het laatst veranderd is.",
        "current_promise_tooltip": "Geeft de prestatie in de huidige periode aan. Klik op een van de icoontjes voor meer informatie.",
        "promise_start_on": "Gestart op {date}",
        "previous_periods": "Vorige periodes",
        "current_difference": "Huidige periode verschil"
      },
      "filter_options": {
        "only_current": "Alleen huidige periode",
        "only_previous": "Alleen vorige periodes",
        "any": "Elke periode"
      },
      "step": {
        "title": "Lange Termijn Prestatie Instelling",
        "description": "We hebben {meter_count} actieve meters gevonden met een gecombineerde piek watt van {peak_watt_sum} Wp.",
        "conservative_title": "Conservatief",
        "conservative_description": "Er is een hoge kans dat deze installatie meer energie produceert dan dit. Je kan kiezen voor deze optie wanneer de condities voor de installtie niet optimaal zijn, bijvoorbeeld wanneer er schaduw is.",
        "optimistic_title": "Optimistisch",
        "optimistic_description": "Dit is onze prognose van de gemiddelde geproduceerde energie in een jaar. Dat is onder optimale condities, dus zonder schaduw. We raden aan om niet hoger te gaan dan deze instelling.",
        "custom_title": "Handmatig",
        "custom_description": "Gebruik deze optie wanneer je een specifieke hoeveelheid energie verwacht. Bijvoorbeeld wanneer er een contract of andere belofte bestaat voor deze installatie.",
        "msg_for_light": "Light installaties behoeven geen instelling voor Lange Termijn Prestatie. Dit kan later ingesteld worden wanneer de installatie wordt omgezet naar Sundata Pro.",
        "current_title": "Huidig",
        "current_description": "Dit is de huidige instelling voor de lange termijn prestatie van deze installatie. Dit kan later veranderd worden."
      }
    },
    "sign_in": {
      "sign_in": "Inloggen",
      "login": "Inloggen",
      "credentials_incorrect": "Ongeldige inloggegevens",
      "password_forgot": "Wachtwoord vergeten"
    },
    "support": {
      "here_to_help": "We zijn er om te helpen",
      "to_knowledge_base": "Open onze kennisbank",
      "chat_support": "Open chat support"
    },
    "tab_export": {
      "filename_allowed_characters": "Bestandsnaam mag alleen letters, cijfers en underscores bevatten",
      "issues": "Exporteer issues naar een spreadsheet",
      "plants_meters": "Exporteer installaties of meters naar een spreadsheet",
      "export_as": "Exporteer als",
      "include_credentials": "Toegangsgegevens toevoegen",
      "report_loading": "Rapport wordt gegenereerd",
      "report_requested": "Rapport wordt aangevraagd",
      "report_wait_for": "Het rapport zal hier beschikbaar komen: {page}",
      "reports_page": "Rapporten pagina",
      "progress_tooltip": "{completed} van de {total} rijen",
      "status": {
        "failed": "Gefaald"
      }
    },
    "tickets": {
      "ticket": "Ticket | Tickets",
      "assign_me": "Wijs toe aan mijzelf",
      "open_tickets": "Open tickets",
      "create_ticket": "Maak ticket aan",
      "create_ticket_for": "Maak ticket aan voor {plant}",
      "no_open": "Er zijn geen open tickets",
      "include_closed": "Inclusief gesloten tickets",
      "support_assigned_title": "Direct contact met Sundata Support",
      "support_assigned_description": "Een supportmedewerker zal je ticket zo snel mogelijk beantwoorden. Dit duurt meestal 1 werkdag.",
      "support_assigned_languages": "Support is mogelijk in zowel Nederlands als Engels.",
      "support_assigned_link": "Voor meer informatie, zie {link}",
      "this_support_article": "dit support artikel",
      "unassigned": "Niet toegewezen",
      "attach_child_company": "Voeg bedrijf toe",
      "company_assign_confirm": "Weet je zeker dat je {company} wilt bijvoegen aan dit ticket?",
      "company_detach_confirm": "Weet je zeker dat je {company} wilt verwijderen van dit ticket?",
      "template_description": "Sjabloon omschrijving",
      "template_name": "Sjabloon naam",
      "template_title": "Sjabloon titel",
      "reopen_ticket": "Heropen ticket",
      "change_template": "Verwissel sjabloon",
      "close_ticket": "Sluit ticket",
      "go_to_plant": "Naar installatie",
      "assignees": "Toegewezenen",
      "assign_confirm": "Weet je zeker dat je {name} wilt toewijzen?",
      "assign_users": "Gebruikers toewijzen",
      "no_assignees": "Geen gebruikers toegewezen",
      "un_assign_confirm": "Weet je zeker dat je {name} af wilt halen van het ticket?",
      "comment_not_empty": "Een reactie kan niet leeg zijn",
      "details_hide": "Verberg details",
      "action_assigned": "was {date} toegevoegd",
      "action_unassigned": "was {date} verwijderd"
    },
    "panel_group": {
      "panel_group": "Paneel groep | Paneel groepen"
    },
    "password": {
      "new": "Nieuw wachtwoord",
      "change": "Verander wachtwoord",
      "confirm": "Bevestig wachtwoord",
      "no_match": "Wachtwoorden komen niet overeen",
      "rule_number": "Wachtwoord moet een nummer bevatten",
      "rule_symbol": "Wachtwoord moet een symbool bevatten",
      "rule_char": "Wachtwoord moet ten minste 8 karakters bevatten"
    },
    "yield_insights": {
      "not_available": "Opbrengst inzichten op het moment niet beschikbaar",
      "tooltip": "Opbrengst inzichten worden bepaald door het vergelijken van opgebrachte- en verwachtte energie voor elke periode over de afgelopen 60 dagen. De dagen met missende opbrengst zijn hier gegroupeerd bij reden."
    },
    "yield_insights_chart": {
      "title": "Mogelijke redenen voor missende energie\nin de afgelopen 60 dagen"
    },
    "go_to_portal_item": {
      "go_to": "Ga naar Portaal",
      "not_supported": "Portaal niet ondersteund"
    },
    "meter_test_item": {
      "run": "Voer {test} uit",
      "production": "productietest",
      "connection": "connectietest"
    },
    "cast4all_check_dialog": {
      "run_for": "Voer {test} uit voor {name}",
      "run": "Druk op de knop om de test te starten",
      "requesting": "De test wordt aangevraagd.",
      "requested": "De test is aangevraagd. Dit kan een minuut of meer duren.",
      "success_production": "De test is successvol afgerond. Gemeten voltage: {voltage}V.",
      "success_connection": "De test is succesvol afgerond met status {status}.",
      "failed": "De test is afgerond met status; {status} en resultaat; {result}."
    },
    "meter_diagnostics": {
      "run": "Voer diagnostiek uit",
      "run_for": "Voer diagnostiek uit voor",
      "meter_existence": "Meter bestaan",
      "meter_existence_validated": "We hebben het bestaan van de meter kunnen valideren.",
      "meter_existence_not_validated": "We konden het bestaan van de meter niet valideren. Weet je zeker dat de toegangsgevens correct zijn?",
      "latest_yield": "Laatste opbrengst",
      "total_recent_yield": "Totale recente opbrengst",
      "alerts": "Meldingen",
      "no_alerts_found": "Geen meldingen gevonden",
      "level": "Niveau"
    },
    "changelog": {
      "idea_invitation": "Heb je een idee of een suggestie? Laat het ons weten via Intercom of klik op dit bericht."
    },
    "reports": {
      "page_description": "Hier bereiden we de rapporten voor.",
      "report_list_plant": "Installatielijst rapport",
      "report_list_meter": "Meterlijst rapport",
      "report_list_issue": "Problemenlijst rapport"
    },
    "issue_values": {
      "yield_promise_status": {
        "tooltip": "Lange Termijn Prestatie Monitoring",
        "extended_tooltip": "Installatie mist lange termijn prestatie"
      },
      "shade": {
        "tooltip": "Schaduw tijdens de dag",
        "extended_tooltip": "Schaduw tijdens de dag"
      },
      "new": {
        "tooltip": "Nieuw aangemaakte installatie",
        "extended_tooltip": "Nieuw aangemaakte installatie"
      },
      "ticket": {
        "tooltip": "Ticket",
        "extended_tooltip": "Ticket"
      },
      "misc": {
        "tooltip": "Overige issues",
        "extended_tooltip": "Overige issues"
      },
      "power_spike": {
        "tooltip": "Stroompiek",
        "extended_tooltip": "Een stroompiek is geobserveerd"
      }
    },
    "metric_values": {
      "new": {
        "tooltip": "Nieuw aangemaakt",
        "extended_tooltip": "Installaties die operationeel zijn geworden in de afgelopen 30 dagen"
      },
      "total": {
        "tooltip": "Totaal aantal installaties",
        "extended_tooltip": "Totaal aantal aangemaakte installaties"
      },
      "open_tickets": {
        "tooltip": "Open Tickets",
        "extended_tooltip": "Alle huidige open tickets"
      },
      "panel_group_update_needed": {
        "tooltip": "Paneelgroepen om te updaten",
        "extended_tooltip": "Installaties die een paneelgroep update nodig hebben"
      }
    }
  },
  "primevue": {
    "accept": "Ja",
    "addRule": "Voeg regel toe",
    "am": "voormiddag",
    "apply": "Toepassen",
    "cancel": "Annuleer",
    "choose": "Kies",
    "chooseDate": "Kies datum",
    "chooseMonth": "Kies maand",
    "chooseYear": "Kies jaar",
    "clear": "Wissen",
    "column": "Kolom",
    "completed": "Voltooid",
    "contains": "Bevat",
    "custom": "Aangepast",
    "dateAfter": "Datum is na",
    "dateBefore": "Datum is voor",
    "dateFormat": "dd-mm-yy",
    "dateIs": "Datum is",
    "dateIsNot": "Datum is niet",
    "dayNames": [
      "zondag",
      "maandag",
      "dinsdag",
      "woensdag",
      "donderdag",
      "vrijdag",
      "zaterdag"
    ],
    "dayNamesMin": ["zo", "ma", "di", "wo", "do", "vr", "za"],
    "dayNamesShort": ["zon", "ma", "di", "woe", "do", "vrij", "zat"],
    "emptyFilterMessage": "Geen resultaten gevonden",
    "emptyMessage": "Geen resultaten gevonden",
    "emptySearchMessage": "Geen resultaten gevonden",
    "emptySelectionMessage": "Geen optie geselecteerd",
    "endsWith": "Eindigt met",
    "equals": "Is gelijk aan",
    "fileSizeTypes": ["B", "KB", "MB", "GB", "TB", "PB", "EB", "ZB", "YB"],
    "filter": "Filter",
    "firstDayOfWeek": 1,
    "gt": "Groter dan",
    "gte": "Groter dan of gelijk aan",
    "lt": "Kleiner dan",
    "lte": "Kleiner dan of gelijk aan",
    "matchAll": "Overeenkomen met alle",
    "matchAny": "Overeenkomen met elke",
    "medium": "Gemiddeld",
    "monthNames": [
      "januari",
      "februari",
      "maart",
      "april",
      "mei",
      "juni",
      "juli",
      "augustus",
      "september",
      "oktober",
      "november",
      "december"
    ],
    "monthNamesShort": [
      "jan",
      "feb",
      "mar",
      "apr",
      "mei",
      "jun",
      "jul",
      "aug",
      "sep",
      "okt",
      "nov",
      "dec"
    ],
    "nextDecade": "Volgend decennium",
    "nextHour": "Volgend uur",
    "nextMinute": "Volgende minuut",
    "nextMonth": "Volgende maand",
    "nextSecond": "Volgende seconde",
    "nextYear": "Volgend jaar",
    "noFilter": "Geen filter",
    "notContains": "Bevat niet",
    "notEquals": "Is niet gelijk aan",
    "now": "Nu",
    "passwordPrompt": "Geef een wachtwoord",
    "pending": "In behandeling",
    "pm": "namiddag",
    "prevDecade": "Vorig decennium",
    "prevHour": "Vorig uur",
    "prevMinute": "Vorige minuut",
    "prevMonth": "Vorige maand",
    "prevSecond": "Vorige seconde",
    "prevYear": "Vorig jaar",
    "reject": "Nee",
    "removeRule": "Verwijder regel",
    "searchMessage": "{0} resultaten beschikbaar",
    "selectionMessage": "{0} opties geselecteerd",
    "showMonthAfterYear": false,
    "startsWith": "Begint met",
    "strong": "Sterk",
    "today": "Vandaag",
    "upload": "Upload",
    "weak": "Zwak",
    "weekHeader": "Wk",
    "aria": {
      "cancelEdit": "Annuleer bewerking",
      "close": "Sluit",
      "collapseLabel": "Instorten",
      "collapseRow": "Rij ingeklapt",
      "editRow": "Bewerk rij",
      "expandLabel": "Uitbreiden",
      "expandRow": "Rij uitgeklapt",
      "falseLabel": "Onwaar",
      "filterConstraint": "Filterbeperking",
      "filterOperator": "Filteroperator",
      "firstPageLabel": "Eerste pagina",
      "gridView": "Roosterweergave",
      "hideFilterMenu": "Verberg filtermenu",
      "jumpToPageDropdownLabel": "Spring naar paginamenu",
      "jumpToPageInputLabel": "Spring naar pagina-invoer",
      "lastPageLabel": "Laatste pagina",
      "listView": "Lijstweergave",
      "moveAllToSource": "Verplaats alle naar bron",
      "moveAllToTarget": "Verplaats alle naar doel",
      "moveBottom": "Verplaats naar beneden",
      "moveDown": "Verplaats omlaag",
      "moveTop": "Verplaats naar boven",
      "moveToSource": "Verplaats naar bron",
      "moveToTarget": "Verplaats naar doel",
      "moveUp": "Verplaats omhoog",
      "navigation": "Navigatie",
      "next": "Volgende",
      "nextPageLabel": "Volgende pagina",
      "nullLabel": "Niet geselecteerd",
      "otpLabel": "Voer een eenmalig wachtwoordteken {0} in",
      "pageLabel": "Pagina {page}",
      "passwordHide": "Verberg wachtwoord",
      "passwordShow": "Laat wachtwoord zien",
      "previous": "Vorige",
      "previousPageLabel": "Vorige pagina",
      "rotateLeft": "Draai linksom",
      "rotateRight": "Draai rechtsom",
      "rowsPerPageLabel": "Rijen per pagina",
      "saveEdit": "Sla bewerking op",
      "scrollTop": "Scroll naar boven",
      "selectAll": "Alle opties geselecteerd",
      "selectLabel": "Selecteer",
      "selectRow": "Rij geselecteerd",
      "showFilterMenu": "Toon filtermenu",
      "slide": "Dia",
      "slideNumber": "{slideNumber}",
      "star": "1 ster",
      "stars": "{star} sterren",
      "trueLabel": "Waar",
      "unselectAll": "Alle opties gedeselecteerd",
      "unselectLabel": "Deselecteer",
      "unselectRow": "Rij gedeselecteerd",
      "zoomImage": "Zoom afbeeling",
      "zoomIn": "Zoom in",
      "zoomOut": "Zoom uit"
    }
  }
}
